/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ScriptStepStatus } from './ScriptStepStatus.js';
import {
    ScriptStepStatusFromJSON,
    ScriptStepStatusFromJSONTyped,
    ScriptStepStatusToJSON,
} from './ScriptStepStatus.js';

/**
 * 
 * @export
 * @interface ScriptStepStatusResponse
 */
export interface ScriptStepStatusResponse {
    /**
     * 
     * @type {ScriptStepStatus}
     * @memberof ScriptStepStatusResponse
     */
    data?: ScriptStepStatus;
    /**
     * 
     * @type {number}
     * @memberof ScriptStepStatusResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof ScriptStepStatusResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ScriptStepStatusResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof ScriptStepStatusResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the ScriptStepStatusResponse interface.
 */
export function instanceOfScriptStepStatusResponse(value: object): boolean {
    return true;
}

export function ScriptStepStatusResponseFromJSON(json: any): ScriptStepStatusResponse {
    return ScriptStepStatusResponseFromJSONTyped(json, false);
}

export function ScriptStepStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScriptStepStatusResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ScriptStepStatusFromJSON(json['data']),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ScriptStepStatusResponseToJSON(value?: ScriptStepStatusResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': ScriptStepStatusToJSON(value['data']),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

